import * as React from 'react';
import { lazy, Suspense } from 'react';
import { Route, useLocation } from 'react-router-dom';
import { AppIcon } from '~/src/app/components/atm.app-icon';
import { TextCenter } from '~/src/atomic/atm.typography';
import { LoadingCentered } from '~/src/atomic/mol.loading';
import { Separator } from '~/src/atomic/obj.box';
import { trackPageView } from '../services/analytics.service';
import { Routes } from '../services/telemetry.service';

const TermsPage = lazy(() => import('./terms/terms.page'));
const CookiesPolicyPage = lazy(() => import('./terms/cookie-policy.page'));
const PrivacyPolicyPage = lazy(() => import('./terms/privacy-policy.page'));
const CheckUserPage = lazy(() => import('./check-user.page'));
const ChangePasswordPage = lazy(() => import('./change-password.page'));
const LoginCodePage = lazy(() => import('./login-code.page'));
const ResetPasswordPage = lazy(() => import('./reset-password.page'));
const UpdateUserPage = lazy(() => import('./update-user.page'));
const LoginPage = lazy(() => import('./login.page'));
const SignUpPage = lazy(() => import('./signup.page'));
const MFAMethodPage = lazy(() => import('./mfa-method.page'));
const MFACodePage = lazy(() => import('./mfa.page'));

export const Paths = {
  CheckUser: '/',
  Login: '/login',
  SignUp: '/cadastro',
  LoginCode: '/login-codigo',
  ResetPassword: '/recuperar-senha',
  CookiePolicy: '/politicas-de-cookies',
  PrivacyPolicy: '/politicas-de-privacidade',
  Terms: '/regulamento',
  UpdateUser: '/atualizar-cadastro',
  ChangePassword: '/trocar-senha',
  MFAMethod: '/metodo-confirmacao-conta',
  MFACode: '/confirmacao-conta',
};

export const AppRoutes: React.FC = () => {
  const location = useLocation();

  React.useEffect(() => {
    trackPageView(location.pathname);
  }, [location]);

  return (
    <>
      <TextCenter>
        <Separator />

        <AppIcon.Logo />
        <Separator />
      </TextCenter>

      <Suspense fallback={<LoadingCentered />}>
        <Routes>
          <Route path={Paths.CheckUser} element={<CheckUserPage />} />
          <Route path={Paths.Login} element={<LoginPage />} />
          <Route path={Paths.LoginCode} element={<LoginCodePage />} />
          <Route path={Paths.MFAMethod} element={<MFAMethodPage />} />
          <Route path={Paths.MFACode} element={<MFACodePage />} />
          <Route path={Paths.SignUp} element={<SignUpPage />} />
          <Route path={Paths.ResetPassword} element={<ResetPasswordPage />} />
          <Route path={Paths.CookiePolicy} element={<CookiesPolicyPage />} />
          <Route path={Paths.PrivacyPolicy} element={<PrivacyPolicyPage />} />
          <Route path={Paths.Terms} element={<TermsPage />} />
          <Route path={Paths.UpdateUser} element={<UpdateUserPage />} />
          <Route path={Paths.ChangePassword} element={<ChangePasswordPage />} />
        </Routes>
      </Suspense>
    </>
  );
};
